import React, { useState, useEffect } from "react";
import {
  Modal,
  Box,
  CardContent,
  IconButton,
  TextField,
  Button,
  styled,
  InputAdornment,
  FormControl,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

import DriveFileRenameOutlineIcon from "@mui/icons-material/DriveFileRenameOutline";

import LocalGroceryStoreIcon from "@mui/icons-material/LocalGroceryStore";
import LinkIcon from "@mui/icons-material/Link";

import axios from "axios";
import { API_BASE_URL } from "../../../apiConfig";
import ArticleEditor from "../manageStores/ArticleEditor";
import { refreshTokenIfNeeded } from "../refreshTokenIfNeeded";
import { useNavigate } from "react-router-dom";

const StyledCard = styled(Box)(({ theme }) => ({
  backgroundColor: "#fff",
  borderRadius: "10px",
  boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
  padding: "20px",
  maxWidth: "1200px",
  width: "77%", // عرض 50% من الشاشة
  margin: "auto",
}));

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "100%",
  maxWidth: 1200,
  bgcolor: "background.paper",
  boxShadow: 24,
  borderRadius: 2,
  p: 4,
};

function EditCoupon({ storeId, onClose, onSubmit }) {
  const [couponData, setCouponData] = useState({
    locationName: "",
    address: "",
    city: "",
    country: "",
  });
  const navigate = useNavigate();

  useEffect(() => {
    const fetchLocationData = async () => {
      try {
        const token = localStorage.getItem("token");

        const response = await axios.get(
          `${API_BASE_URL}Coupon/Find/${storeId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );

        setCouponData({
          storeID: response.data.storeID,
          couponTitle: response.data.couponTitle,
          couponDescription: response.data.couponDescription,
          couponCode: response.data.couponCode,
          affiliatelink: response.data.affiliatelink,
        });
      } catch (error) {
        if (error.response?.status === 401) {
          try {
            const newToken = await refreshTokenIfNeeded();

            if (!newToken) {
              return navigate("/", { replace: true });
            }

            // إعادة الطلب بالتوكن الجديد
            const response = await axios.get(
              `${API_BASE_URL}Coupon/Find/${storeId}`,
              {
                headers: {
                  Authorization: `Bearer ${newToken}`,
                },
              },
            );

            setCouponData({
              storeID: response.data.storeID,
              couponTitle: response.data.couponTitle,
              couponDescription: response.data.couponDescription,
              couponCode: response.data.couponCode,
              affiliatelink: response.data.affiliatelink,
            });
          } catch (retryError) {
            console.error("Retry failed:", retryError);
          }
        } else {
          console.error("Error fetching user data:", error);
        }
      }
    };

    fetchLocationData();
  }, [storeId]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setCouponData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleDescriptionChange = (value) => {
    setCouponData((prevData) => ({
      ...prevData,
      couponDescription: value,
    }));
  };

  const handleSubmit = async () => {
    if (
      !couponData.storeID ||
      !couponData.couponTitle ||
      !couponData.couponDescription ||
      !couponData.couponCode ||
      !couponData.affiliatelink
    ) {
      alert("يرجى ملئ الحقول المطلوبة");
      return;
    }

    const formData = new FormData();
    formData.append("storeID", couponData.storeID);
    formData.append("couponTitle", couponData.couponTitle);
    formData.append("couponDescription", couponData.couponDescription);
    formData.append("couponCode", couponData.couponCode);
    formData.append("affiliatelink", couponData.affiliatelink);

    try {
      const token = localStorage.getItem("token");

      await axios.put(`${API_BASE_URL}Coupon/Update/${storeId}`, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      });

      alert("تم تعديل الكوبون بنجاح");
      onSubmit();
      onClose();
    } catch (error) {
      if (error.response?.status === 401) {
        try {
          const newToken = await refreshTokenIfNeeded();

          if (!newToken) {
            return navigate("/", { replace: true });
          }

          // إعادة الطلب بالتوكن الجديد
          const retryFormData = new FormData();
          retryFormData.append("storeID", couponData.storeID);
          retryFormData.append("couponTitle", couponData.couponTitle);
          retryFormData.append(
            "couponDescription",
            couponData.couponDescription,
          );
          retryFormData.append("couponCode", couponData.couponCode);
          retryFormData.append("affiliatelink", couponData.affiliatelink);

          await axios.put(
            `${API_BASE_URL}Coupon/Update/${storeId}`,
            retryFormData,
            {
              headers: {
                Authorization: `Bearer ${newToken}`,
                "Content-Type": "multipart/form-data",
              },
            },
          );

          alert("تم تعديل الكوبون بنجاح");
          onSubmit();
          onClose();
        } catch (retryError) {
          alert("Retry failed: " + retryError.message);
        }
      } else {
        console.error("Error updating user:", error);
        alert("حدث خطأ أثناء تعديل الكوبون");
      }
    }
  };

  return (
    <Modal
      dir="rtl"
      open={true}
      onClose={onClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <StyledCard>
          <IconButton
            onClick={onClose}
            sx={{ position: "absolute", top: 16, right: 16 }}
          >
            <CloseIcon />
          </IconButton>
          <CardContent sx={{ textAlign: "right", mt: 2 }}>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                marginBottom: "3%",
                fontFamily: "'Changa', sans-serif",
              }}
            >
              <h3>تعديل كوبون</h3>
            </div>

            <Box
              sx={{ display: "flex", justifyContent: "space-between", mt: 2 }}
            >
              {/* الصورة على اليسار */}
              <Box
                sx={{
                  width: "40%",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <FormControl fullWidth sx={{ marginBottom: 2 }}>
                  <TextField
                    placeholder="عنوان الكوبون"
                    value={couponData.couponTitle}
                    name="couponTitle"
                    onChange={handleChange}
                    variant="outlined"
                    sx={{
                      backgroundColor: "#fff",
                      borderRadius: "4px",
                      "& .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#5b5b5c",
                      },
                      "&:hover .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#5b5b5c",
                      },
                      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#0064b7",
                      },
                    }}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <LocalGroceryStoreIcon sx={{ color: "green" }} />
                        </InputAdornment>
                      ),
                    }}
                  />
                </FormControl>

                <FormControl fullWidth sx={{ marginBottom: 2 }}>
                  <TextField
                    placeholder="كود الخصم"
                    value={couponData.couponCode}
                    name="couponCode"
                    onChange={handleChange}
                    variant="outlined"
                    sx={{
                      backgroundColor: "#fff",
                      borderRadius: "4px",
                      "& .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#5b5b5c",
                      },
                      "&:hover .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#5b5b5c",
                      },
                      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#0064b7",
                      },
                    }}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <DriveFileRenameOutlineIcon sx={{ color: "blue" }} />
                        </InputAdornment>
                      ),
                    }}
                  />
                </FormControl>

                <FormControl fullWidth sx={{ marginBottom: 2 }}>
                  <TextField
                    placeholder="رابط الافلييت"
                    value={couponData.affiliatelink}
                    name="affiliatelink"
                    onChange={handleChange}
                    variant="outlined"
                    sx={{
                      backgroundColor: "#fff",
                      borderRadius: "4px",
                      "& .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#5b5b5c",
                      },
                      "&:hover .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#5b5b5c",
                      },
                      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#0064b7",
                      },
                    }}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <LinkIcon sx={{ color: "green" }} />
                        </InputAdornment>
                      ),
                    }}
                  />
                </FormControl>
              </Box>
              <Box sx={{ width: "55%" }}>
                <FormControl fullWidth sx={{ marginBottom: 1 }}>
                  <ArticleEditor
                    value={couponData.couponDescription}
                    onChange={handleDescriptionChange}
                  />
                </FormControl>
              </Box>
            </Box>

            <Box sx={{ textAlign: "center", mt: 4 }}>
              <Button
                variant="contained"
                color="primary"
                onClick={handleSubmit}
              >
                تعديل الكوبون
              </Button>
            </Box>
          </CardContent>
        </StyledCard>
      </Box>
    </Modal>
  );
}

export default EditCoupon;
